"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    signUpRequired: true,
    forgetPasswordRequired: true,
    verificationType: 'link' //SignUp verification type(code or link)
};
exports.default = config;
//# sourceMappingURL=index.js.map